import React from "react";
import autoBind from "react-autobind";
import {Link} from "react-router-dom";
import Paper from "@material-ui/core/Paper";
import Field from "../../components/Field";
import Logo from "../../components/Logo";
import noty from "../../lib/noty";
import Button from "@material-ui/core/Button";
import LinearProgress from "@material-ui/core/LinearProgress";
import feathers from "../../feathers";

export default class PasswordForgot extends React.Component {
  constructor(props) {
    super(props);
    this.forgotService = feathers.service("auth/password-forgot");
    this.state = {
      error: null,
      fetching: false,
      data: {
        email: ""
      }
    };
    autoBind(this);
  }

  handleSubmit(event) {
    event.preventDefault();
    const {email} = this.state.data;
    this.setState({fetching: true, error: false});
    this.forgotService
      .create({email})
      .then(resp => {
        noty.success(resp.message);
        this.setState({
          error: null,
          fetching: false
        });
      })
      .catch(err => {
        this.setState({
          error: err.message,
          fetching: false
        });
      });
  }

  handleChange({name, value}) {
    this.setState({data: {...this.state.data, [name]: value}});
  }

  render() {
    return (
      <div className="unauthed-page">
        <div className="container-fluid">
          <div className="row middle-md middle-sm middle-xs">
            <div className="col-md-4 col-md-offset-4 col-sm-6 col-sm-offset-3 col-xs-12">
              <Paper className="unauthed-box">
                <div className="logo-container">
                  <Logo width={200} />
                </div>
                <form onSubmit={this.handleSubmit}>
                  <div className="row margin-bottom-30">
                    <div className="col-xs-12">
                      <Field
                        label="Email"
                        name="email"
                        type="email"
                        value={this.state.data.email}
                        onChange={this.handleChange}
                        disabled={this.state.fetching}
                      />
                    </div>
                  </div>
                  <div className="row middle-xs">
                    <div className="col-xs">
                      <Link to="/login" className="small text-muted link">
                        Login
                      </Link>
                      <span className="small text-muted">,&nbsp;</span>
                      <Link to="/signup" className="small text-muted link">
                        Sign Up
                      </Link>
                    </div>
                    <div className="col-xs">
                      <Button
                        variant="contained"
                        type="submit"
                        color="primary"
                        style={{float: "right"}}
                        onClick={this.handleSubmit}
                        disabled={this.state.fetching}>
                        Submit
                      </Button>
                    </div>
                  </div>
                </form>
              </Paper>
              {this.state.fetching && <LinearProgress mode="indeterminate" />}
              {this.state.error && <div className="unauthed-error">{this.state.error}</div>}
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/PasswordForgot/index.jsx